<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="应收明细账"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="getDataFunc"
      @status-change="cellFun"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <customer  @restaurants='setSupplier' :state='params.TradeUnitName'/>
        </el-form-item>
        <!--<el-form-item label="查询类型">
          <el-select size="mini" v-model="params.Type" clearable>
            <el-option label="普通应收" :value="0" />
            <el-option label="预收" :value="1" />
            <el-option label="其它应收" :value="2" />
          </el-select>
        </el-form-item>-->
        <el-form-item label="对账周期">
          <el-select size="mini" v-model="params.Cycle" @change="cycleChange" clearable>
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账日期" v-if="!isMB">
          <range-picker :date="[params.DocDateStart,params.DocDateEnd]" @change="dateChange" />
        </el-form-item>
        <template v-else>
          <el-form-item label="对账日期">
            <el-date-picker
              v-model="params.DocDateStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-date-picker
              v-model="params.DocDateEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束时间"
            ></el-date-picker>
          </el-form-item>
        </template>
        <el-form-item label="对账期间">
          <range-picker month :s-date="sDate" :e-date="eDate" :date="date" @change="monthChange" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column
          v-for="(item,index) in InledgerdtsList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          align='center'
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="item.prop=='DocDate'" :style="{ textAlign: item.align }">
              {{$commonJs.toDateString(scope.row.DocDate)}}
            </div>
            <div v-else-if="item.prop=='DocNo'" :style="{ textAlign: item.align }">
              <el-button type="text">{{ scope.row.DocNo }}</el-button>
            </div>
            <div v-else :style="{ textAlign: item.align }">{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <customTableDialog ref="customTableDialog" @onSave="onSave" :initTableData='setInledgerdtsList' :tableType='tableType'/>
    <!-- <customer ref="customer" selectable @select="setTradeunit" /> -->
    
    <bill-dialog ref="billDialog"  />
    <sales-return-dialog ref="salesReturnDialog"  />
    <salreturn-dialog ref="salreturnDialog"  />
    <income-dialog ref="incomeDialog"  />
    <orec-dialog ref="orecDialog"  />
    <receiptdoc-dialog ref="receiptdocDialog"  />

  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
// import customer from "@/components/basicinfo/basic/logistics/listDialog";
import customer from "@/components/common/customer/customer";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

import billDialog from "@/components/sales/business/bill/detailsDialog";//销货单
import salesReturnDialog from "@/components/sales/business/return/editDialog";//销货退货单
import salreturnDialog from "@/components/sales/business/salreturn/editDialog";//商城销售退货单
import incomeDialog from "@/components/fund/contactcash/income/detailsDialog";//收入单
import orecDialog from "@/components/fund/contactcash/orec/detailsDialog";//其他应收单
import receiptdocDialog from "@/components/cashier/receiptdoc/detailsDialog";//收款单


export default {
  mixins: [listMixin],
  components: { 
    list, customer,customTableDialog,
    billDialog,salesReturnDialog,salreturnDialog,incomeDialog,orecDialog,receiptdocDialog
  },
  data() {
    return {
      api: require("@/api/fund/receipt").default,
      params: {
        Type: null,
        DocDateStart: null,
        DocDateEnd: null,
        MonthStart: null,
        MonthEnd: null,
        TradeUnitId: null,
        TradeUnitName: "",
        Cycle: "",
      },
      isMB: this.$store.state.isMB,
      tableType:'应收明细账动态列',
      setInledgerdtsList: [
        {
          prop:'TradeUnitName',
          label:'客户名称',
          isShow:true,
          width:'180px',
          align:'center',
        },
        {
          prop:'DocDate',
          label:'日期',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'DpName',
          label:'部门',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'EmpName',
          label:'经办人',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'Remark',
          label:'备注',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'SrcVouTypeName',
          label:'单据类型',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'BusinessTypeName',
          label:'业务类型',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'DocNo',
          label:'单据编号',
          isShow:true,
          width:'180px',
          align:'center'
        },
        {
          prop:'NeedAmount',
          label:'应收',
          isShow:true,
          width:'180px',
          align:'right'
        },
        {
          prop:'AlreadyAmount',
          label:'已收',
          isShow:true,
          width:'180px',
          align:'right'
        },
        {
          prop:'LeftAmount',
          label:'余额',
          isShow:true,
          width:'180px',
          align:'right'
        },
      ]
    };
  },
  mounted(){
    if(localStorage.getItem(this.tableType)){
      this.setInledgerdtsList = JSON.parse(localStorage.getItem(this.tableType))
    }else{
      localStorage.setItem('应收明细账动态列',JSON.stringify(this.setInledgerdtsList));
    }
  },
  computed: {
    // 过滤不需要显示的列
	  InledgerdtsList: function () {
	    return this.setInledgerdtsList.filter(function (item) {
		    return item.isShow;
	    })
	  },
    date() {
      return [this.params.MonthStart, this.params.MonthEnd];
    },
    sDate() {
      return this.$dayjs().endOf("month").format("YYYY-MM-DD");
    },
    eDate() {
      return this.$dayjs()
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
    /** 动态列弹框保存 */
    onSave(){
      this.setInledgerdtsList = JSON.parse(localStorage.getItem(this.tableType))
      this.$message.success("保存成功");
    },
    onCustomTable(){
      this.$refs.customTableDialog.dialogVisible = true
    },
    setSupplier(data) {
        
        this.params.TradeUnitId = data.TradeUnitId;
        this.params.TradeUnitName = data.TradeUnitName;
    },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        if (!params.DocDateStart) params.DocDateStart = params.MonthStart;
        if (!params.DocDateEnd) params.DocDateEnd = params.MonthEnd;

        this.api.getListDetailRcv(params).then((res) => resolve(res));
      });
    },
    openTradeunit() {
      this.$refs.customer.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.Id;
      this.params.TradeUnitName = data.Name;
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    monthChange(val) {
      this.params.MonthStart = val.Start;
      this.params.MonthEnd = val.End;
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
    onExport1() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.exportDetail(this.params).then(() => {
        loading.close();
      });
    },
    onExport2() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.exportCollect(this.params).then(() => {
        loading.close();
      });
    },
    cellFun(row, column){
      if (column.property == "DocNo") {
        switch (row.SrcVouTypeName) {
          case '销货单':
            this.$refs.billDialog.setReadonly(false)
            this.$refs.billDialog.openDetailsById(row.SourceId);
            break;
          case '销货退货单':
            this.$refs.salesReturnDialog.openEditById(row.SourceId);
            break;
          case '商城销售退货单':
            sessionStorage.setItem("check", "1"); 
            this.$refs.salreturnDialog.openEditById(row.SourceId);
            break;
          case '收入单':
            sessionStorage.setItem('check','1')
            this.$refs.incomeDialog.openEditById(row.SourceId);
            break;
          case '其它应收单':
            this.$refs.orecDialog.openDetailsById(row.SourceId);
            break;
          case '收款单':
            this.$refs.receiptdocDialog.openDetailsById(row.SourceId);
            break;
          default:
            this.$message.error('未知单据类型');
          break;
        }
      }
    }
  },
};
</script>